import { loadTemplate } from "utils/load_template"
import { arrayDiff } from "utils/array_difference"
import SlimSelect from 'slim-select'

class SelectRefinementWidget {
  constructor(widgetParams={}) {
    this.placeholderText = "Please make a selection"
    this.selectedValues = []
    this.dropdown = null
    this.selectType = widgetParams.selectType || "multiple"
    this.buildWidget(widgetParams)
  }

  buildWidget(widgetParams) {
    const customRenderFn = (renderParams, isFirstRendering) => {
      const container = document.getElementById(renderParams.widgetParams.container)
      const title = renderParams.widgetParams.title || "Filter by"
      const attribute = renderParams.widgetParams.attribute

      if (isFirstRendering) {
        container.innerHTML = loadTemplate(`${this.selectType}-select-filter-template`).interpolateObject({ attribute: attribute })
        this.dropdown = this.buildSelect(container, renderParams)
      }

      const data = this.loadDataValues(renderParams)

      this.selectedValues = data.filter((el) => { return el.selected || el.options }).map((el) => {
        if (el.options) {
          return el.options.filter((el) => { return el.selected }).map((el) => { return el.value })
        } else {
          return el.value
        }
      }).flat()

      this.dropdown.setData(data)
    }

    this.mainWidget = (widgetParams.connector || instantsearch.connectors.connectRefinementList)(customRenderFn)
  }

  get widget(){
    return this.mainWidget
  }

  set widget(widget) {
    this.mainWidget = widget
  }

  isMultiple() {
    return this.selectType === "multiple"
  }

  refineItems(renderParams, data, selectedValues) {
    let newItems

    if (this.isMultiple()) {
      newItems = data.map((option) => { return option.value })
    } else {
      newItems = data.value && data.value !== this.placeholderText ? [data.value] : []
    }

    const itemsToRefine = arrayDiff(this.selectedValues, newItems)
    itemsToRefine.forEach((item) => { renderParams.refine(item) })
  }

  buildSelect(container, renderParams) {
    return new SlimSelect({
      select: container.querySelector("select"),
      settings: {
        placeholderText: this.placeholderText,
        allowDeselect: this.isMultiple(),
        showSearch: true
      },
      events: {
        afterChange: (data) => {
          this.refineItems(renderParams, data, this.selectedValues)
        }
      }
    })
  }

  loadDataValues(renderParams) {
    let data

    if (Array.isArray(renderParams.widgetParams.items)) {
      data = renderParams.widgetParams.items.map((staticItem) => {
        return { text: staticItem.label, value: staticItem.value,
          selected: renderParams.items.find((item) => item.value.toString() === staticItem.value.toString() && item.isRefined) || false
        }
      })
    } else {
      data = renderParams.items.map((item) => {
        const itemStruct = [ { text: item.label, value: item.value, selected: item.isRefined } ]

        if (item.data) {
          const options = []
          item.data.forEach((child) => { options.push({ text: child.label, value: child.value, selected: child.isRefined }) })
          itemStruct.push({ label: "", options: options })
        }

        return itemStruct
      })
    }

    if (!this.isMultiple()) {
      data.unshift({
        text: this.placeholderText,
        value: null
      })
    }

    return data.flat()
  }
}

export default SelectRefinementWidget
